<template>
    <BOverlay :show="is_load">
        <BTable
            class="cursor-pointer"
            striped
            @row-clicked="onRowClicked"
            :items="history"
            :fields="fields"
            show-empty >
            
            <template  v-slot:cell(added)="data">
                {{fmtDate(data.item.added)}}
            </template>
            
            <template  v-slot:cell(type_id)="data">
                {{data.item?.type?.title}}
            </template>
            
            <template #row-details="row">
                <BCard >
                    <div v-html="row.item.message.body"></div>
                </BCard>
            </template>
        </BTable>
    </BOverlay>
</template>

<script>
import {
    BOverlay,
    BTable,
    BCard
} from 'bootstrap-vue-next';
import grid from "../../../../../shared/list/grid/grid.vue";

export default {
    name: "cont_email_history",
    props : {
        contragent : {
            type : Object,
            required : true,
        }
    },
    components : {
        grid,
        BTable,
        BOverlay,
        BCard,
    },
    
    data() {
        return {
            is_load : false,
            history : [],
            fields : [
                { key: 'id', sortable: true },
                { key: 'added', label: 'Дата'  },
                { key: 'type_id', label: 'Тип'  },
                { key: 'email_from', label: 'Надіслав'  },
            ],
        }
    },
    
    created() {
        this.loadHistory();
    },
    
    methods : {
        onRowClicked(item, index) {
            // оставить только один открытым:
          //  this.history.forEach((it, i) => { if (i !== index) it._showDetails = false })
            item._showDetails = !item._showDetails
            // Альтернатива одной строкой:
            // this.$refs.tbl?.toggleRowDetails?.(index)
        },
        
        async loadHistory() {
            this.is_load = true;
            this.history = [];
            
            await api.get('/tenders/sales/tenders/contragents/' + parseInt(this.contragent.id) + '/email/history').then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.history = data.data;
                }
            }).catch(e => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    }
}
</script>


<style scoped>

</style>